<template>
  <v-container fluid class="pa-0">
    <v-layout column>
      <v-flex xs12>
        <v-toolbar flat>
          <v-toolbar-title>Istoric modificari Simboluri</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical>
          </v-divider>
          <v-btn icon @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-select
            v-model="diffOperations"
            :items="operationsList"
            prepend-icon="mdi-gesture-tap"
            :menu-props="{ maxHeight: '400' }"
            label="Operatiuni"
            clearable
            multiple
            hide-details>
          </v-select>
          <v-select
            v-model="diffUser"
            :items="usernames"
            prepend-icon="mdi-account"
            :menu-props="{ maxHeight: '400' }"
            label="Cautare user (username)"
            clearable
            multiple
            hide-details>
          </v-select>
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            prepend-icon="mdi-domain"
            v-model="diffEntity"
            append-icon="mdi-magnify"
            label="Cautare simbol (id scara)"
            single-line
            clearable
            hide-details>
          </v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 style="position: relative; flex-basis: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :rows-per-page-items="[5, 10, 15, 20, 25, 50]"
          item-key="_id">
          <template v-slot:items="{ item }">
            <td style="white-space: nowrap">
              <v-btn icon small class="ma-0" @click="viewDiffData(item)">
                <v-icon small :color="onColor">mdi-eye</v-icon>
              </v-btn>
            </td>
            <td>{{ item.operation }}</td>
            <td>{{ item.user }}</td>
            <td>{{ item.id_scara }}</td>
            <td>{{ new Date(item.createdAt).toLocaleString('ro-RO') }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-dialog v-model="niceDialog" persistent max-width="90vw" scrollable>
      <v-card flat max-height="75vh">
        <v-card-title>
          <h1 class="headline">
            Diferente
          </h1>
        </v-card-title>
        <v-card-text style="flex-grow: 1">
          <div v-html="niceDiff" :class="{ light: light, dark: !light }"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeNiceDialog">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import 'jsondiffpatch/dist/formatters-styles/html.css'
const jsondiffpatch = require('jsondiffpatch')

export default {
  name: 'share-diff',

  data: () => ({
    headers: [
      { text: 'actiuni', value: 'actions', sortable: false },
      { text: 'operatiune', value: 'operation', sortable: false },
      { text: 'username', value: 'user', sortable: false },
      { text: 'simbol', value: 'id_scara', sortable: false },

      { text: 'data', value: 'createdAt', sortable: false }
    ],
    niceDiff: null,
    niceDialog: false
  }),

  computed: {
    onColor () {
      return this.$store.getters.onColor
    },
    loading () {
      return this.$store.getters.loading
    },
    items () {
      return this.$store.getters.diff
    },
    totalItems () {
      return this.$store.getters.diffTotal
    },
    pagination: {
      get () {
        return this.$store.getters.diffPagination
      },
      set (value) {
        this.$store.dispatch('setDiffPagination', value)
      }
    },
    light () {
      return this.$store.getters.light
    },
    diffEntity: {
      get () {
        return this.$store.getters.diffEntity
      },
      set (value) {
        this.$store.dispatch('setDiffEntity', value)
      }
    },
    diffUser: {
      get () {
        return this.$store.getters.diffUser
      },
      set (value) {
        this.$store.dispatch('setDiffUser', value)
      }
    },
    diffOperations: {
      get () {
        return this.$store.getters.diffOperations
      },
      set (value) {
        this.$store.dispatch('setDiffOperations', value)
      }
    },
    usernames () {
      return this.$store.getters.usernames
    },
    operationsList () {
      return this.$store.getters.operationsList
    }
  },

  methods: {
    refresh () {
      this.$store.dispatch('fetchDiff')
    },
    viewDiffData (item) {
      const delta = jsondiffpatch.diff(item.oldvalue, item.newvalue)

      // beautiful html diff
      jsondiffpatch.formatters.html.hideUnchanged()
      this.niceDiff = jsondiffpatch.formatters.html.format(delta, item.oldvalue)
      this.niceDialog = true
    },
    closeNiceDialog () {
      this.niceDialog = false
      this.niceDiff = null
    }
  },

  mounted () {
    this.$store.dispatch('fetchDiff')
    this.$store.dispatch('fetchUsers')
  }
}
</script>

<style lang="stylus">
  .light {
    .jsondiffpatch-added .jsondiffpatch-property-name,
    .jsondiffpatch-added .jsondiffpatch-value pre,
    .jsondiffpatch-modified .jsondiffpatch-right-value pre,
    .jsondiffpatch-textdiff-added {
      background: #bbffbb;
    }
    .jsondiffpatch-deleted .jsondiffpatch-property-name,
    .jsondiffpatch-deleted pre,
    .jsondiffpatch-modified .jsondiffpatch-left-value pre,
    .jsondiffpatch-textdiff-deleted {
      background: #ffbbbb;
      text-decoration: line-through;
    }
  }

  .dark {
    .jsondiffpatch-added .jsondiffpatch-property-name,
    .jsondiffpatch-added .jsondiffpatch-value pre,
    .jsondiffpatch-modified .jsondiffpatch-right-value pre,
    .jsondiffpatch-textdiff-added {
      background: #77bb77;
    }
    .jsondiffpatch-deleted .jsondiffpatch-property-name,
    .jsondiffpatch-deleted pre,
    .jsondiffpatch-modified .jsondiffpatch-left-value pre,
    .jsondiffpatch-textdiff-deleted {
      background: #aa6666;
      text-decoration: line-through;
    }
  }
</style>
